import { createContext, useContext } from 'react';
import type { Path } from 'react-hook-form';
import type { IComponent, IGcfComponentConfig } from 'src/interfaces';

export interface EditComponentPageContextProps {
  componentDetails: IComponent;
  handleChangeComponentDetails: (
    updatedComponent?: any,
    field?:
      | Path<IComponent & { config: IGcfComponentConfig }>
      | Array<Path<IComponent & { config: IGcfComponentConfig }>>,
  ) => void;
  isCustomerKnown?: boolean;
  setIsCustomerKnown?: (isKnown: boolean) => void;
}

export const EditComponentPageContext =
  createContext<EditComponentPageContextProps | null>(null);

export const useEditComponentPageContext = () => {
  const context = useContext(EditComponentPageContext);

  if (!context) {
    throw new Error(
      'useEditComponentPageContext must be used within a EditComponentPageContext',
    );
  }

  return context;
};
